import React, { useState, useEffect } from "react";
import { Table, Pagination, Spin, Divider } from "antd";
import axios from "axios";
import reportServices from "../../services/pollination-report-service";
import { es } from "date-fns/locale/es";
import { useForm } from "react-hook-form";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import moment from "moment";
import config from "../../config/config";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import pollinationSevice from "../../services/pollination-service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";


import DatePicker from "react-datepicker";

const DuplicateReport = () => {

  registerLocale("es", es);

  const [farmId, setFarmId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [lotId, setLotId] = useState("0");



  const start_date =moment().startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);
  ///Aplicaciones por dia
  const [initReport, setInitReport] = useState(false);

  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);



  const getLisUsers = async () => {
    let listado = await userService.getListByRol("OPERADOR");
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListUsers(sortedItems);
      //setValue("farm",0)
    }
  };


  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListSection(escoja);
      setListLots(escoja);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("user", "0")
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("user", "0")
    }
  };



  const getLisLots = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLots(escoja);
      setValue("lot", "0")
      setValue("user", "0")
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      setValue("lot", "0")
      setValue("user", "0")
    }
  };



  const generateExcel = async () => {
    setInitReport(true)

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const response = await reportServices.generateDetailedExcel(start, end, farmId, sectionId, lotId, userId);
      if (response?.error) {
        toast.error("No hay registros", { autoClose: 1600 })
        setLoading(false);
        return;
      }
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `detallado ${start} - ${end}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }



  const searchMovements = async (page, pageSize) => {
    setInitReport(true)

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(startDate).endOf("day").format('YYYY-MM-DD');

    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      setPage(1);
      const response = await reportServices.duplicateReport(1, pageSize, start, end, farmId, sectionId, lotId, userId);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchMovements = async (page, pageSize) => {

    if (!initReport) return;



   
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(startDate).endOf("day").format('YYYY-MM-DD');

    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const response = await reportServices.duplicateReport(page, pageSize, start, end, farmId, sectionId, lotId, userId);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  };



  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "date",
      key: "date",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Usuario",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Finca",
      dataIndex: "farmName",
      key: "farmName",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
    },
    // Agrega más columnas según sea necesario
  ];


  const deleteMovement =  async(id,operator,line,palm)=>{
      const username = localStorage.getItem("username");
      if (username != "superadmin") {
        toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
        return;
      }
      else {
        Swal.fire({
          title: `Eliminar registro`,
          html: `Desea eliminar el registro de ${operator}<br/>Linea ${line} Palma ${palm}?`,
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar registro",
          denyButtonText: `Conservar`
        }).then(async (result) => {
          if (result.isConfirmed) {
            const data = { id};
            const success = await pollinationSevice.deleteMovement(data);
            if (success) {
              fetchMovements(1,pageSize)
              toast('Realizado.', { autoClose: 1000 });
            }
          }
        });
      }
    }



  

  useEffect(() => {
    getLisFarm();
    getListFilterUsers()
  }, []);

  useEffect(() => {
    fetchMovements(page, pageSize);
  }, [page, pageSize]);


    const getListFilterUsers = async () => {
    const userId = "0"
    try {
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListFilterUsers();
  }, [startDate, endDate, sectionId, farmId, lotId]);



  return (
    <div className="row p-4">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Palmas visitadas por el mismo usuario</Divider>
      </div>

      <div className="col-12">
        <form className="form-react">
          <div className="row mb-3">
            <div className="col-12 col-sm-10">
              <div className="row">



                <div className=" col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Finca</label>
                  <select
                    className="form-control text-secondary"
                    {...register("farm")}
                    onChange={(e) => {
                      getListSection(e)
                      const value = e.target.value
                      setSectionId("0")
                      setLotId("0")
                      setFarmId(value)
                    }}
                  >
                    {listFarms.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Sección</label>
                  <select
                    className="form-control text-secondary"
                    {...register("section")}
                    onChange={(e) => {
                      getLisLots(e)
                      const value = e.target.value
                      setSectionId(value)
                      setLotId("0")
                    }}
                  >
                    {listSection.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-12 col-sm-4">
                  <label className="text-secondary fw-bold">Lote</label>
                  <select
                    className="form-control text-secondary"
                    {...register("lot")}
                    onChange={(e) => {
                      setValue("user", "0")
                      const value = e.target.value
                      setLotId(value)

                    }}
                  >
                    {listLots.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>





                <div className="col-6 col-sm-2">
                  <label className="text-secondary fw-bold">Fecha</label>
                  <br />
                  <DatePicker
                    locale="es"
                    dateFormat="yyyy-MM-dd"
                    className="form-control text-secondary"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                </div>

                <div className="col-6 col-sm-2 d-none">
                  <label className="text-secondary fw-bold">Hasta</label>
                  <br />
                  <DatePicker
                    locale="es"
                    dateFormat="yyyy-MM-dd"
                    className="form-control 
                              text-secondary"
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                  />
                </div>

                <div className=" col-12 col-sm-4 d-none">
                  <label className="text-secondary fw-bold">Usuario</label>
                  <select
                    className="form-control text-secondary"
                    {...register("user")}
                    onChange={(e) => {
                      const value = e.target.value;
                    }}
                  >
                    {listUsers.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>





              </div>
            </div>


            <div className="col-12 col-sm-2">

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => searchMovements(page, pageSize)}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>

              <div className=" col-12 d-none">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={() => generateExcel()}
                  >
                    <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                  </button>
                </Spin>
              </div>

            </div>
          </div>
        </form>
      </div>

      <Pagination
        className="text-primary "
        current={page}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        pageSizeOptions={["10", "20", "50"]}
        showTotal={(total) => `Total ${total} registros`}
        showSizeChanger
        onShowSizeChange={(current, size) => handlePageChange(1, size)}
      />
      <Spin spinning={loading}>
        <div className="card mt-3" style={{ minHeight: "400px" }}>

          <div className="table-responsive">
            <table className="table">
              <thead className="table-primary">
                <tr>
                  <th>Fecha</th>
                  <th>Usuario</th>
                  <th>Finca</th>
                  <th>Lote</th>
                  <th>Línea</th>
                  <th>Palma</th>
                  <th>1ra</th>
                  <th>2da</th>
                  <th>3ra</th>
                  <th>S/A</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td width="100px" >{item.date.split("T")[0]}</td>
                    <td>{item.userName}</td>
                    <td>{item.farmName}</td>
                    <td>{item.lotName}</td>
                    <td>{item.lineName}</td>
                    <td>{item.palmName}</td>
                    <td>{item.totalFirst}</td>
                    <td>{item.totalSecond}</td>
                    <td>{item.totalThird}</td>
                    <td >{item.totalWithoutApplication}</td>
                    <td>{item.total}</td>
                    <td>
                       <button
                          className="btn btn-secondary ms-2"
                          onClick={() => deleteMovement(item.idMovement,item.userName,item.lineName,item.palmName)}
                        >
                          <i className="bi bi-trash fa-lg m-1" />
                        </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Spin>
    </div>
  );
};


export default DuplicateReport;
